// extracted by mini-css-extract-plugin
module.exports = {"container":"search-modal_container___PNJ8"};